import React from 'react'
import { CustomHTMLSelect } from 'src/consumer/components/helperComponents'
import { PRINT_PAGE_ARRAY } from 'src/consumer/constants'

export default function ReciptPrintingPageSizeSelector({ value, onChange }) {
  return (
    <div>
      <CustomHTMLSelect
        label="Print Size"
        value={value == null ? '' : value}
        onChange={(e) => {
          onChange(e.target.value)
        }}
        options={PRINT_PAGE_ARRAY}
        getOptionValue={(optn) => optn?.id}
        getOptionLabel={(optn) => optn?.title}
      />
    </div>
  )
}
